import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import getTripConfirmationChanges from './getTripConfirmationChanges';

const TripConfirmationChanges = ({ tripId }) => {
  const trip = useSelector((state) => state.trip.selectedTrips[tripId]);
  const [passengersChanges, setPassengersChanges] = useState({});
  const [viewInsuranceChanges, setViewInsuranceChanges] = useState(false);
  const [viewPackageChanges, setViewPackageChanges] = useState(false);
  const [viewServiceChanges, setViewServiceChanges] = useState(false);
  const [viewCruiseTransportChanges, setViewCruiseTransportChanges] = useState(false);
  const [viewDiningChanges, setViewDiningChanges] = useState(false);

  const { passengers, tripConfirmation } = useSelector((store) => store.trip);
  useEffect(() => {
    setPassengersChanges(getTripConfirmationChanges(passengers,
      trip && trip.addPaymentMethodToTravelTypes, trip, tripConfirmation));
  }, [trip, passengers, tripConfirmation]);

  return passengersChanges.hasChanges ? (
    <div className="border-2 rounded text-xs p-2 mt-4 border-theme border-opacity-50">
      <div>
        <b>Changes:</b>
      </div>
      <ul className="list-disc list-inside">
        {passengersChanges.doAddPaymentMethod && <li>Add payment to booking</li>}
        {passengersChanges.insuranceChanges.length > 0 && (
          <li>
            Passenger insurance changed
            {' '}
            <a className="text-theme underline font-bold" role="button" tabIndex="0" onKeyDown={() => { }} onClick={() => setViewInsuranceChanges((v) => !v)}>
              View changes
            </a>
            {viewInsuranceChanges && (
              <div className="px-5 py-2">
                <ul className="list-circle list-inside">
                  {passengersChanges.insuranceChanges.map((p) => (
                    <li key={`${p.passenger?.firstName} - ${p.passenger?.lastName} - ${p.action}`}>
                      {`${p.action} insurance for ${p.passenger.firstName} ${p.passenger.lastName}`}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        )}
        {passengersChanges.packageChanges.length > 0 && (
          <li>
            Package changed
            {' '}
            <a className="text-theme underline font-bold" role="button" tabIndex="0" onKeyDown={() => { }} onClick={() => setViewPackageChanges((v) => !v)}>
              View changes
            </a>
            {viewPackageChanges && (
              <div className="px-5 py-2">
                <ul className="list-circle list-inside">
                  {passengersChanges.packageChanges.map((p) => (
                    <li key={`${p.package.packageName || p.package.packageCode} - ${p.passenger.firstName} - ${p.passenger.lastName} - ${p.action}`}>
                      {`${p.action} package ${p.package.packageName || p.package.packageCode} for ${p.passenger.firstName} ${p.passenger.lastName}`}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        )}
        {passengersChanges.servicesChanges.length > 0 && (
          <li>
            Special services changed
            {' '}
            <a className="text-theme underline font-bold" role="button" tabIndex="0" onKeyDown={() => { }} onClick={() => setViewServiceChanges((v) => !v)}>
              View changes
            </a>
            {viewServiceChanges && (
              <div className="px-5 py-2">
                <ul className="list-circle list-inside">
                  {passengersChanges.servicesChanges.map((p) => (
                    <li key={`${p.passenger.firstName}-${p.passenger.lastName}-${p.service.description}-${p.action}`}>
                      {`${p.action} service ${p.service.description} for ${p.passenger.firstName} ${p.passenger.lastName}`}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        )}
        {passengersChanges.cruiseTransportChanges.length > 0 && (
          <li>
            Cruise transport changed
            {' '}
            <a className="text-theme underline font-bold" role="button" tabIndex="0" onKeyDown={() => { }} onClick={() => setViewCruiseTransportChanges((v) => !v)}>
              View changes
            </a>
            {viewCruiseTransportChanges && (
              <div className="px-5 py-2">
                <ul className="list-circle list-inside">
                  {passengersChanges.cruiseTransportChanges.map((p) => (
                    <li key={`${p.passenger.firstName}-${p.passenger.lastName}`}>
                      {`Changed transport for ${p.passenger.firstName} ${p.passenger.lastName}`}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        )}
        {passengersChanges.diningChanges.length > 0 && (
          <li>
            Dining preferences changed
            {' '}
            <a className="text-theme underline font-bold" role="button" tabIndex="0" onKeyDown={() => { }} onClick={() => setViewDiningChanges((v) => !v)}>
              View changes
            </a>
            {viewDiningChanges && (
              <div className="px-5 py-2">
                <ul className="list-circle list-inside">
                  {passengersChanges.diningChanges.map((p) => <li key={p}>{p}</li>)}
                </ul>
              </div>
            )}
          </li>
        )}
      </ul>
    </div>
  ) : <></>;
};

TripConfirmationChanges.propTypes = {
  tripId: PropTypes.string.isRequired,
};

export default TripConfirmationChanges;
